// extracted by mini-css-extract-plugin
export var menuItem = "R_xP d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "R_xQ d_Z d_bz d_bP";
export var menuMainLink = "R_xR d_f0 d_dB";
export var menuLink = "R_xS d_f0 d_dB";
export var icon = "R_n9 d_bC d_bP";
export var divider = "R_xT d_bC d_bP";
export var sublinks = "R_xV";
export var link = "R_mC";
export var Link = "R_vs G_vs G_tV G_vd";